export default {
  path: 'settings/saved_locations',
  name: 'TemporaryRegulationsLocations',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/LocationsIndex.vue')
}
